'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * StringHelper provides string.format functionality.
 * Starts with the last {i} and works to {0}.
 *
 * @class StringHelper
 *
 */
String.prototype.format = function () {
  // eslint-disable-line no-extend-native
  var args = Array.prototype.slice.call(arguments);
  var transformation = null;
  if (typeof args[0] === 'function') {
    transformation = args.shift();
  }
  var s = this,
      i = args.length;
  while (i--) {
    var arg = args[i];
    if (transformation) {
      arg = transformation(arg);
    }
    s = s.replace('{' + i + '}', arg);
  }
  return s;
};

var StringHelper = {
  isUndefinedOrNullOrEmpty: function isUndefinedOrNullOrEmpty(val) {
    return typeof val === 'undefined' || val === null || typeof val === 'string' && val.trim() === '';
  }
};

if (!String.concatEid) {
  String.concatEid = function (value) {
    value = value || '';

    for (var _len = arguments.length, concatValues = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      concatValues[_key - 1] = arguments[_key];
    }

    return value.concat('.').concat(concatValues.join('.'));
  };
}

exports.default = StringHelper;